import { IDataSet, track, resetEventHandlerData } from '../Track';
import Game from '../../../Game';
import { SocialActionEventName } from '../TrackingEvent';

export enum SocialActionTypes {
    WALLPOST_SHARE_3_STAR_REWARD = 'WALLPOST_SHARE_3_STAR_REWARD',
    WALLPOST_SHARE_CROP_UNLOCKED = 'WALLPOST_SHARE_CROP_UNLOCKED',
    WALLPOST_SHARE_PET_UNLOCKED = 'WALLPOST_SHARE_PET_UNLOCKED',
    WALLPOST_SHARE_FIELD_UNLOCKED = 'WALLPOST_SHARE_FIELD_UNLOCKED',
    WALLPOST_SHARE_PET_JACKPOT = 'WALLPOST_SHARE_PET_JACKPOT',
    WALLPOST_SHARE_LUCKY_WHEEL_REWARD = 'WALLPOST_SHARE_LUCKY_WHEEL_REWARD',
    WALLPOST_SHARE_PREMIUM_WHEEL_REWARD = 'WALLPOST_SHARE_PREMIUM_WHEEL_REWARD',
    WALLPOST_SHARE_HARD_LEVEL = 'WALLPOST_SHARE_HARD_LEVEL',
    WALLPOST_SHARE_FARM = 'WALLPOST_SHARE_FARM',
    CUSTOM_BEST_HIGH_SCORE_LEVEL = 'CUSTOM_BEST_HIGH_SCORE_LEVEL',
    CUSTOM_UNLOCK_FRIEND_RESPONSE = 'CUSTOM_UNLOCK_FRIEND_RESPONSE',
    CUSTOM_FRIEND_REQUEST = 'CUSTOM_FRIEND_REQUEST',
    CUSTOM_SEND_GIFT = 'CUSTOM_SEND_GIFT',
    CUSTOM_INVITE_FRIEND = 'CUSTOM_INVITE_FRIEND',
    CUSTOM_GIVE_CURRENCY = 'CUSTOM_GIVE_CURRENCY',
    CUSTOM_REQUEST_CURRENCY = 'CUSTOM_REQUEST_CURRENCY',
    CUSTOM_SEND_CURRENCY = 'CUSTOM_SEND_CURRENCY',
}

export class SocialActionDataSet implements IDataSet {
    public targetUserID: string = undefined;
    public actionText: string = undefined;
    public actionLevel: number = 0;
    public socialAction: string = undefined;
}

interface SocialActionEventProps {
    type: SocialActionTypes;
    text: string;
    friendId?: string;
}
export const addAndSendSocialActionEvent = ({
    type,
    text,
    friendId,
}: SocialActionEventProps) => {
    track('socialAction', type);
    track('actionText', text);
    track('actionLevel', Game.store.getState().levelState.levelNumber);
    track('targetUserID', friendId);
    resetEventHandlerData(SocialActionEventName.socialAction, Game.store.getState());
};
